import React from 'react';
import { FormSelect, FormSelectOption } from '@patternfly/react-core';
import { countries } from 'countries-list';

interface CountryOption {
  value: string;
  label: string;
  disabled?: boolean;
}

interface CountrySelectProps {
  value: string;
  onChange: (value: string) => void;
  includeEmpty?: boolean;
  emptyLabel?: string;
}

export const CountrySelect: React.FC<CountrySelectProps> = ({
  value,
  onChange,
  includeEmpty = true,
  emptyLabel = 'Select a country',
}) => {
  // Convert countries object to array and sort by name
  const countryOptions: CountryOption[] = React.useMemo(() => {
    const options = Object.entries(countries).map(([code, country]) => ({
      value: code,
      label: `${country.name} (${code})`,
      disabled: false,
    }));

    // Sort by country name
    options.sort((a, b) => a.label.localeCompare(b.label));

    // Add empty option if requested
    if (includeEmpty) {
      options.unshift({
        value: '',
        label: emptyLabel,
        disabled: true,
      });
    }

    return options;
  }, [includeEmpty, emptyLabel]);

  const handleChange = (_event: React.FormEvent<HTMLSelectElement>, value: string) => {
    onChange(value);
  };

  return (
    <FormSelect value={value} onChange={handleChange} aria-label="Country select" ouiaId="CountrySelect">
      {countryOptions.map((option) => (
        <FormSelectOption key={option.value} value={option.value} label={option.label} isDisabled={option.disabled} />
      ))}
    </FormSelect>
  );
};
